import { withSentry } from '../modules/sentry';
import toggleRecipeSteps from '../modules/recipe';
import $dom from 'cash-dom';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import VuePluralize from 'vue-pluralize';
import 'waypoints';
import { carousel, reviewCarousel } from '../modules/carousel';

import { globalEventBusPlugin } from '@pixelcabin/ui-utils/lib/vue';

import VariantSelector from '../components/VariantSelector/VariantSelector.vue';
import { variantSelectorPreprocessProps } from '../components/VariantSelector/preprocess_props';

import LocationFinder from '../components/LocationFinder/LocationFinder.vue';
import { LocationFinderPreprocessProps } from '../components/LocationFinder/preprocess_props';

import AssociatedProducts from '../components/AssociatedProducts/AssociatedProducts.vue';
import { associatedProductsPreprocessProps } from '../components/AssociatedProducts/preprocess_props';

import ProductInfoCaption from '../components/ProductInfoCaption/ProductInfoCaption.vue';
import { productInfoCaptionPreprocessProps } from '../components/ProductInfoCaption/preprocess_props';

$dom.fn.ready(
  withSentry(() => {
    console.log('[product] initializing scripts');
    toggleRecipeSteps();
    carousel();
    reviewCarousel();

    Vue.use(globalEventBusPlugin);
    Vue.use(vueCustomElement);
    Vue.use(VuePluralize);

    Vue.customElement(
      'pxl-variant-selector',
      VariantSelector,
      variantSelectorPreprocessProps
    );

    Vue.customElement(
      'location-finder',
      LocationFinder,
      LocationFinderPreprocessProps
    );

    Vue.customElement(
      'associated-products',
      AssociatedProducts,
      associatedProductsPreprocessProps
    );

    Vue.customElement(
      'product-info-caption',
      ProductInfoCaption,
      productInfoCaptionPreprocessProps
    );

    new window.Waypoint({
      element: document.getElementById('MainContent'),
      handler: function (direction) {
        if (direction === 'down') {
          $dom('.sticky-add-to-cart-container').addClass('visible');
        } else {
          $dom('.sticky-add-to-cart-container').removeClass('visible');
        }
      }
    });
  })
);
